import React, { memo } from "react";
import { Link, Ul } from "@pochta/ui";

var ErrorPageRightLinks = function ErrorPageRightLinks(_ref) {
  var _ref$subscriptionOnli = _ref.subscriptionOnline,
      subscriptionOnline = _ref$subscriptionOnli === void 0 ? null : _ref$subscriptionOnli,
      _ref$postcards = _ref.postcards,
      postcards = _ref$postcards === void 0 ? null : _ref$postcards,
      _ref$telegrams = _ref.telegrams,
      telegrams = _ref$telegrams === void 0 ? null : _ref$telegrams,
      _ref$email = _ref.email,
      email = _ref$email === void 0 ? null : _ref$email,
      _ref$pochtaMarket = _ref.pochtaMarket,
      pochtaMarket = _ref$pochtaMarket === void 0 ? null : _ref$pochtaMarket,
      _ref$pochtaBank = _ref.pochtaBank,
      pochtaBank = _ref$pochtaBank === void 0 ? null : _ref$pochtaBank,
      _ref$electronicAppeal = _ref.electronicAppeals,
      electronicAppeals = _ref$electronicAppeal === void 0 ? null : _ref$electronicAppeal;
  return /*#__PURE__*/React.createElement(Ul, {
    listStyleType: "none"
  }, /*#__PURE__*/React.createElement(Ul.Li, null, /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: subscriptionOnline
  }, "\u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430 \u043E\u043D\u043B\u0430\u0439\u043D")), /*#__PURE__*/React.createElement(Ul.Li, null, /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: postcards
  }, "\u041E\u0442\u043A\u0440\u044B\u0442\u043A\u0438"), " ", "\u0438", " ", /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: telegrams
  }, "\u0442\u0435\u043B\u0435\u0433\u0440\u0430\u043C\u043C\u044B")), /*#__PURE__*/React.createElement(Ul.Li, null, /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: email
  }, "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u043F\u0438\u0441\u044C\u043C\u0430")), /*#__PURE__*/React.createElement(Ul.Li, null, /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: pochtaMarket
  }, "\u041F\u043E\u0447\u0442\u0430\u041C\u0430\u0440\u043A\u0435\u0442"), " ", "\u0438", " ", /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: pochtaBank
  }, "\u041F\u043E\u0447\u0442\u0430\u0411\u0430\u043D\u043A")), /*#__PURE__*/React.createElement(Ul.Li, null, /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    href: electronicAppeals
  }, "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F")));
};

export default /*#__PURE__*/memo(ErrorPageRightLinks);